import {ref} from 'vue';

export const numHedenReady = ref<number>(-1);
export const numHedenTodo  = ref<number>(-1);
